// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"ea4d4871","165":"4bb11529","524":"9bf07943","666":"3f422c17","796":"06a9543a","872":"026ee98a","895":"d81b055f"}[chunkId] + ".chunk.js";
};